



































import Flickity from "vue-flickity";
import { downloadAttachments } from '@/utilities/downloadAttachments';
export default {
    name: 'attachmentImageViewer',
    components: {
        Flickity
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => {
                return false;
            },
        },
        imagesToPreview: {
            type: Array,
            required: true,
            default: () => {
                return [] as [];
            },
        },
        selectedAttachmentIndex: {
            type: Number,
            required: false,
            default: 0
        }
    },
    watch: {
        selectedAttachmentIndex(val) {
            if (!this.$refs.flickity) return;
            this.$refs.flickity.select(val || (this.$refs.flickity.selectedIndex() || 0));
        }
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 0,
                pageDots: false,
                freeScroll: false,
                contain: true,
                prevNextButtons: true,
                imagesLoaded: true,
                lazyLoad: 1,
            },
            stillInLoading: false
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val: Boolean) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        closeViewerOverlay() {
            this.inputVal = false;
        },
        handelImageError(e: any) {
            e.target.src = require('@/assets/image-placeholder.png');
        },
        resetCarousel() {
            if (this.$refs.flickity) {
                this.$refs.flickity.rerender();
            }
        },
        downloadAttachment() {
            const selectedIndex = this.$refs.flickity?.selectedIndex();
            if ([null, undefined].includes(selectedIndex)) return;
            
            const fileUrl = this.imagesToPreview[selectedIndex].metadata.file_url;
            const attachmentTitle = this.imagesToPreview[selectedIndex].title;
            downloadAttachments(fileUrl, attachmentTitle);
        }
    }
};
